export const SITE = {
  name: "The Music Highway",
  fullName: "The Music Highway - School of Music",
  slogan: "School of Music",
  slotsLeft: 6,
  address: "C/504, Shiv Koliwada Building, Opp. Croma Store, Road No. 29, Sion East, Mumbai - 400022",
  whatsapp: "917738772358",
  phoneDisplay: "+91 77387 72358",
  email: "themusichighway2@gmail.com",
  instagram: "https://www.instagram.com/themusichighway/",
  instagramHandle: "@themusichighway",
  timings: "Monday to Thursday: 4 PM - 9 PM · Saturday: 2 PM - 9 PM · Friday & Sunday: Closed",
};

export const waLink = (text) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(text)}`;

export const PLAY_FIRST_WA =
  "Hi, I'd like to book my 2 free sessions at The Music Highway. Instrument: ___. Preferred day and time: ___.";

export const SMALL_PRINT =
  "Valid for new students only. Both sessions must be completed within 7 days of booking. Missed sessions can be rebooked for a nominal fee of Rs 199.";

export const TRIAL_WA = "Hi, I'd like to book a free trial class at The Music Highway";